<div style="height: calc(100%); width: 100%;" data-cy="draw-text-container">
  <mat-card appearance="outlined" style="width: 100%; height: calc(100%); display: flex; flex-direction: column;" data-cy="draw-text-card">
    <span class="configuration-section-title" data-cy="draw-text-title">Text Tools</span>
    <app-tdo-configuration-action-bar newHidden="true" (saveClick)="onSave($event)" data-cy="draw-text-action-bar"></app-tdo-configuration-action-bar>

    <!-- Text Object Section -->
    <mat-card-title data-cy="draw-text-object-title">Text Object</mat-card-title>
    <mat-card-subtitle data-cy="draw-text-object-subtitle">Text object default font.</mat-card-subtitle>
    <div data-cy="draw-text-example-container">
      <p data-cy="draw-text-example-text">Example Text</p>
    </div>

    <table style="width: 618px; border-spacing: 0 8px;" data-cy="draw-text-table">
      <!-- Font Settings Row -->
      <tr data-cy="draw-text-font-row">
        <td style="width: 200px; height: 50px;" data-cy="draw-text-font-field">
          <tdo-dropdown-v2 *ngIf="drawTextDefaults" widthString="200px" placeholder="Font" placeholderPosition="above" [datasource]="enumFonts" displayProperty="name" [value]="leadToolsHelper.getFont(this.drawTextDefaults.fontTxt)" (selectionChange)="onFontChangeTxt($event); dropdownChange($event);" data-cy="draw-text-font-dropdown"></tdo-dropdown-v2>
        </td>
        <td style="width: 6px;"></td>
        <td style="width: 40px; height: 50px;" data-cy="draw-text-font-size-field">
          <tdo-dropdown-v2 *ngIf="drawTextDefaults" widthString="200px" placeholder="Size" placeholderPosition="above" [datasource]="FontSizes" displayProperty="value" [value]="leadToolsHelper.getFontSize(this.drawTextDefaults.fontSizeTxt)" (selectionChange)="onFontSizeChangeTxt($event); dropdownChange($event);" data-cy="draw-text-font-size-dropdown"></tdo-dropdown-v2>
        </td>
        <td style="width: 6px;"></td>
        <td style="width: 200px; height: 50px;" data-cy="draw-text-font-style-field">
          <tdo-dropdown-v2 *ngIf="drawTextDefaults" widthString="200px" placeholder="Style" placeholderPosition="above" [datasource]="enumFontStyles" displayProperty="name" [value]="leadToolsHelper.getFontStyle(this.drawTextDefaults.fontStyleTxt)" (selectionChange)="onFontStyleChangeTxt($event); dropdownChange($event);" data-cy="draw-text-font-style-dropdown"></tdo-dropdown-v2>
        </td>
      </tr>

      <!-- Colors Row -->
      <tr data-cy="draw-text-colors-row">
        <td style="width: 200px;" data-cy="draw-text-background-color-field">
          <app-tdo-color-picker label="Background Color" style="width: 100%;" placeholder="Background color" [color]="backgroundTxt" (colorChange)="onBackgroundColorChangeTxt($event); configurationService.setDirty();" data-cy="draw-text-background-color-picker"></app-tdo-color-picker>
        </td>
        <td style="width: 6px;"></td>
        <td style="width: 40px;" data-cy="draw-text-foreground-color-field">
          <app-tdo-color-picker label="Foreground Color" style="width: 100%;" placeholder="Foreground color" [color]="foregroundTxt" (colorChange)="onForegroundColorChangeTxt($event); configurationService.setDirty();" data-cy="draw-text-foreground-color-picker"></app-tdo-color-picker>
        </td>
        <td style="width: 6px;"></td>
        <td style="width: 200px;"></td>
      </tr>

      <!-- Border Settings Row -->
      <tr data-cy="draw-text-border-row">
        <td style="width: 200px;" data-cy="draw-text-border-color-field">
          <app-tdo-color-picker label="Border Color" style="width: 100%;" placeholder="Border Color" [color]="borderColorTxt" (colorChange)="onBorderColorChangeTxt($event); configurationService.setDirty();" data-cy="draw-text-border-color-picker"></app-tdo-color-picker>
        </td>
        <td style="width: 6px;"></td>
        <td style="width: 40px; height: 50px;" data-cy="draw-text-line-width-field">
          <tdo-dropdown-v2 *ngIf="drawTextDefaults" widthString="200px" placeholder="Line Width" placeholderPosition="above" [datasource]="Widths" displayProperty="value" [value]="leadToolsHelper.getWidth(this.drawTextDefaults.lineWidthTxt)" (selectionChange)="onWidthChangeTxt($event); dropdownChange($event);" data-cy="draw-text-line-width-dropdown"></tdo-dropdown-v2>
        </td>
        <td style="width: 6px;"></td>
        <td style="width: 200px;"></td>
      </tr>
    </table>

    <br />

    <!-- Text Pointer Object Section -->
    <mat-card-title data-cy="draw-text-pointer-title">Text Pointer Object</mat-card-title>
    <mat-card-subtitle data-cy="draw-text-pointer-subtitle">Text pointer object default font.</mat-card-subtitle>
    <p data-cy="draw-text-pointer-example-text">Example Text</p>

    <table style="width: 618px; border-spacing: 0 8px;" data-cy="draw-text-pointer-table">
      <!-- Font Settings Row -->
      <tr data-cy="draw-text-pointer-font-row">
        <td style="width: 200px; height: 50px;" data-cy="draw-text-pointer-font-field">
          <tdo-dropdown-v2 *ngIf="drawTextDefaults" widthString="200px" placeholder="Font" placeholderPosition="above" [datasource]="enumFonts" displayProperty="name" [value]="leadToolsHelper.getFont(this.drawTextDefaults.fontTxtPtr)" (selectionChange)="onFontChangeTxtPtr($event); dropdownChange($event);" data-cy="draw-text-pointer-font-dropdown"></tdo-dropdown-v2>
        </td>
        <td style="width: 6px;"></td>
        <td style="width: 40px; height: 50px;" data-cy="draw-text-pointer-font-size-field">
          <tdo-dropdown-v2 *ngIf="drawTextDefaults" widthString="200px" placeholder="Size" placeholderPosition="above" [datasource]="FontSizes" displayProperty="value" [value]="leadToolsHelper.getFontSize(this.drawTextDefaults.fontSizeTxtPtr)" (selectionChange)="onFontSizeChangeTxtPtr($event); dropdownChange($event);" data-cy="draw-text-pointer-font-size-dropdown"></tdo-dropdown-v2>
        </td>
        <td style="width: 6px;"></td>
        <td style="width: 200px; height: 50px;" data-cy="draw-text-pointer-font-style-field">
          <tdo-dropdown-v2 *ngIf="drawTextDefaults" widthString="200px" placeholder="Style" placeholderPosition="above" [datasource]="enumFontStyles" displayProperty="name" [value]="leadToolsHelper.getFontStyle(this.drawTextDefaults.fontStyleTxtPtr)" (selectionChange)="onFontStyleChangeTxtPtr($event); dropdownChange($event);" data-cy="draw-text-pointer-font-style-dropdown"></tdo-dropdown-v2>
        </td>
      </tr>

      <!-- Colors Row -->
      <tr data-cy="draw-text-pointer-colors-row">
        <td style="width: 200px;" data-cy="draw-text-pointer-background-color-field">
          <app-tdo-color-picker label="Background Color" style="width: 100%;" placeholder="Background color" [color]="backgroundTxtPtr" (colorChange)="onBackgroundColorChangeTxtPtr($event); configurationService.setDirty();" data-cy="draw-text-pointer-background-color-picker"></app-tdo-color-picker>
        </td>
        <td style="width: 6px;"></td>
        <td style="width: 40px;" data-cy="draw-text-pointer-foreground-color-field">
          <app-tdo-color-picker label="Foreground Color" style="width: 100%;" placeholder="Foreground color" [color]="foregroundTxtPtr" (colorChange)="onForegroundColorChangeTxtPtr($event); configurationService.setDirty();" data-cy="draw-text-pointer-foreground-color-picker"></app-tdo-color-picker>
        </td>
        <td style="width: 6px;"></td>
        <td style="width: 200px;"></td>
      </tr>

      <!-- Border Settings Row -->
      <tr data-cy="draw-text-pointer-border-row">
        <td style="width: 200px;" data-cy="draw-text-pointer-border-color-field">
          <app-tdo-color-picker label="Border Color" style="width: 100%;" placeholder="Border Color" [color]="borderColorTxtPtr" (colorChange)="onBorderColorChangeTxtPtr($event); configurationService.setDirty();" data-cy="draw-text-pointer-border-color-picker"></app-tdo-color-picker>
        </td>
        <td style="width: 6px;"></td>
        <td style="width: 40px; height: 50px;" data-cy="draw-text-pointer-line-width-field">
          <tdo-dropdown-v2 *ngIf="drawTextDefaults" widthString="200px" placeholder="Line Width" placeholderPosition="above" [datasource]="Widths" displayProperty="value" [value]="leadToolsHelper.getWidth(this.drawTextDefaults.lineWidthTxtPtr)" (selectionChange)="onWidthChangeTxtPtr($event); dropdownChange($event);" data-cy="draw-text-pointer-line-width-dropdown"></tdo-dropdown-v2>
        </td>
        <td style="width: 6px;"></td>
        <td style="width: 200px;"></td>
      </tr>
    </table>
  </mat-card>
</div>

